module.exports = __webpack_public_path__ + "static/img/CgoRC2OhePmAWGwGAAM-EewbU9w370.fa084ae.e6ddbed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2OhePmAWGwGAAM-EewbU9w370.fa084ae.jpg
// module id = QF5W
// module chunks = 73